import { StartConsultationContainer } from '../containers/StartConsultationContainer/index'
 
export const StartConsultationPage = () => (
    <StartConsultationContainer/>
)